var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMealtimes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Mealtimes.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Mealtimes",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(56.0886,44.6334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.468,-0.133 -2.988,-0.271 -4.541,-0.212 -1.886,0.073 -3.104,1.488 -4.177,2.736 -1.643,1.911 -2.831,3.29 -6.03,1.877 -1.059,-0.467 -1.321,-1.054 -1.814,-2.335 -0.741,-1.924 -1.754,-4.561 -6.737,-5.379 -4.705,-0.772 -6.416,-1.515 -7.014,-1.883 L 10.626,-5.534 C 8.822,-4.918 7.14,-3.829 6.425,-1.69 5.778,0.243 4.475,0.409 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(18.2092,30.629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.927,-1.659 -0.614,-3.776 0.759,-5.15 0.749,-0.749 1.29,-0.833 2.11,-0.961 1.264,-0.198 3.174,-0.497 4.412,-3.409 1.352,-3.182 4.445,-5.238 7.881,-5.238 h 28.063 c 3.435,0 6.528,2.056 7.88,5.238 1.238,2.912 3.148,3.211 4.412,3.409 0.82,0.128 1.361,0.213 2.11,0.961 C 59,-3.776 59.313,-1.659 58.386,0 56.865,2.722 54,4.413 50.91,4.413 H 7.477 C 4.385,4.413 1.521,2.722 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(77.4234,71.6684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.351,0 -0.686,-0.106 -0.971,-0.306 l -0.541,-0.556 c -2.943,-3.027 -6.281,-5.647 -9.92,-7.787 l -3.751,-2.205 -0.198,-0.117 -0.209,0.097 c -0.635,0.292 -1.363,0.441 -2.165,0.441 -1.621,0 -3.341,-0.606 -4.843,-1.705 -3.064,-2.243 -4.253,-5.85 -2.65,-8.04 0.761,-1.04 2.046,-1.613 3.617,-1.613 1.622,0 3.344,0.606 4.848,1.707 2.289,1.675 3.594,4.147 3.324,6.297 l -0.028,0.228 0.171,0.154 3.227,2.901 c 3.146,2.828 6.659,5.221 10.442,7.112 l 0.684,0.342 c 0.349,0.267 0.577,0.653 0.645,1.092 0.07,0.45 -0.038,0.899 -0.305,1.264 C 1.059,-0.259 0.544,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(83.0587,69.0981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.227,-1.463 -0.998,-2.763 -2.171,-3.659 L -2.472,-3.888 -2.81,-4.057 -3.494,-4.399 c -3.462,-1.731 -6.677,-3.921 -9.556,-6.509 l -2.061,-1.853 c -0.321,-2.971 -2.102,-5.9 -4.945,-7.981 -0.079,-0.057 -0.162,-0.107 -0.241,-0.163 1.531,-0.62 2.816,-1.802 3.545,-3.981 0.407,-1.217 2.278,-1.59 4.683,-1.95 2.18,-0.327 4.24,-0.636 5.053,-2.448 0.378,-0.843 0.347,-1.786 -0.09,-2.814 1.685,-1.099 3.117,-2.599 4.134,-4.42 1.796,-3.213 1.211,-7.297 -1.422,-9.93 -1.671,-1.671 -3.266,-1.92 -4.321,-2.085 -0.942,-0.147 -0.979,-0.153 -1.347,-1.02 -1.981,-4.662 -6.519,-7.674 -11.563,-7.674 h -28.063 c -5.043,0 -9.581,3.012 -11.562,7.674 -0.369,0.867 -0.406,0.873 -1.349,1.02 -1.055,0.165 -2.649,0.414 -4.319,2.085 -2.633,2.633 -3.219,6.716 -1.424,9.93 1.568,2.806 4.117,4.859 7.071,5.831 -0.229,0.662 -0.302,1.414 -0.026,2.224 0.76,2.232 3.67,3.531 10.38,4.633 2.72,0.446 3.051,1.306 3.651,2.867 0.552,1.435 1.307,3.399 3.931,4.559 3.557,1.571 6.048,0.938 7.861,-0.263 -0.226,1.376 -0.116,2.847 0.366,4.312 0.761,2.306 2.363,4.442 4.513,6.015 2.182,1.597 4.741,2.477 7.205,2.477 0.652,0 1.284,-0.061 1.891,-0.181 l 2.404,1.413 c 3.331,1.959 6.386,4.356 9.079,7.127 l 0.541,0.557 0.263,0.27 0.309,0.217 c 0.962,0.674 2.092,1.03 3.268,1.03 1.814,0 3.536,-0.871 4.605,-2.332 C -0.133,3.011 0.233,1.506 0,0 m -49.705,15.735 c 8.599,0 15.594,-6.995 15.594,-15.594 0,-8.599 -6.995,-15.594 -15.594,-15.594 -8.599,0 -15.595,6.995 -15.595,15.594 0,8.599 6.996,15.594 15.595,15.594 m 36.931,4.073 c -22.922,12.637 -51.748,4.3 -64.386,-18.621 -12.638,-22.922 -4.3,-51.749 18.621,-64.386 22.922,-12.638 51.748,-4.301 64.386,18.621 12.638,22.922 4.301,51.748 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(31.3533,75.6417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,1.104 0.896,2 2,2 3.104,2 4,1.104 4,0 v -5.574 l 1.798,-1.798 c 0.782,-0.781 0.782,-2.047 0.001,-2.829 -0.391,-0.39 -0.903,-0.586 -1.415,-0.586 -0.511,0 -1.023,0.196 -1.414,0.586 L 0.586,-7.817 C 0.579,-7.81 0.574,-7.802 0.568,-7.795 0.483,-7.708 0.405,-7.614 0.337,-7.513 0.302,-7.46 0.278,-7.404 0.248,-7.348 0.216,-7.289 0.179,-7.232 0.153,-7.168 0.125,-7.101 0.109,-7.03 0.088,-6.96 0.072,-6.905 0.051,-6.852 0.04,-6.795 0.014,-6.665 0,-6.534 0,-6.402 Z m 2,-17.997 c 6.394,0 11.595,5.201 11.595,11.594 0,6.394 -5.201,11.595 -11.595,11.595 -6.393,0 -11.594,-5.201 -11.594,-11.595 0,-6.393 5.201,-11.594 11.594,-11.594",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealtimes);
export default __webpack_public_path__ + "static/media/mealtimes.0201d91b3952e4edb9e4f9078585eae2.svg";
export { ForwardRef as ReactComponent };